import { render, staticRenderFns } from "./Deletionrecord.vue?vue&type=template&id=41b1fe9a&scoped=true"
import script from "./Deletionrecord.vue?vue&type=script&lang=js"
export * from "./Deletionrecord.vue?vue&type=script&lang=js"
import style0 from "./Deletionrecord.vue?vue&type=style&index=0&id=41b1fe9a&prod&scoped=true&lang=css"
import style1 from "./Deletionrecord.vue?vue&type=style&index=1&id=41b1fe9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b1fe9a",
  null
  
)

export default component.exports